import { render } from "./AdminApproved25Liquidations.vue?vue&type=template&id=3a9f085a"
import script from "./AdminApproved25Liquidations.vue?vue&type=script&lang=js"
export * from "./AdminApproved25Liquidations.vue?vue&type=script&lang=js"

import "./AdminApproved25Liquidations.vue?vue&type=style&index=0&id=3a9f085a&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__